module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EPy6c6/tc-custom/9781541539471.jpg?1703823905404",
      "alt": "This image is the cover for the book Prince Harry & Meghan, Gateway Biographies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Prince Harry & Meghan, Gateway Biographies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("American actress Meghan Markle is not a typical royal. Upon hearing the news of her engagement to Prince Harry, royal watchers cheered the addition of a woman of color to the royal family. This profile chronicles how Prince Harry met the American actress, their relationship, and their journey toward becoming a new kind of royal family.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jill Sherman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jill Sherman writes fiction and nonfiction books for young readers. She started out her career in publishing as an editor, but soon discovered that her real joy was in writing. She has written dozens of books for young people, including fiction works, as well as news and magazine articles for print and digital publications. She thoroughly enjoys researching new topics to provide young readers with the best information that they can use in their own studies. Jill lives and writes in Brooklyn, New York. ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Lerner Publications\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0